module.exports = __webpack_public_path__ + "media/careers/careers_bg--overlay-mobile-6fe892f2.png";